/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import { Tabs, Badge } from "antd-mobile";
import { connect } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";
import Theme from "../../utils/Theme";
import * as _ from "underscore";
import * as selectors from "../../selectors";
import * as userAction from "../../actions/user";
import QueueListing from "../../components/QueueListing";
import LoadingIndicator from "../../components/LoadingIndicator";
import "./index.css";

const StyledContainer = styled.div`
  background: #f4f4f4;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
`;

class FoodQueuePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animationClass: null,
      current: 0,
      tabs: [
        {
          title: intl.formatMessage({
            id: "queue.page.tab.in.progress.title",
            defaultMessage: "In Progress",
            description: "Queue Page In Progress Title"
          })
        },
        {
          title: intl.formatMessage({
            id: "queue.page.tab.completed.title",
            defaultMessage: "Completed",
            description: "Queue Page Completed Title"
          })
        }
      ]
    };
  }

  componentDidMount() {
    const { authToken } = this.props;
    this.configureNavBar();

    if (authToken) {
      this.fetchQueueItemData();
      this.fetchQueueCompleteItemData();
    }

    this.queueMyInterval = setInterval(this.refreshAllQueue.bind(this), 5000);
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let tabData = this.state.tabs;

    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchQueueItemData();
        this.fetchQueueCompleteItemData();
      }
    }

    if (!_.isEmpty(this.props.completeData)) {
      if (nextProps.completeData.length !== this.props.completeData.length) {
        tabData[1] = {
          title: (
            <Badge dot className="food-queue-badge">
              {intl.formatMessage({
                id: "queue.page.tab.completed.title",
                defaultMessage: "Completed",
                description: "Queue Page Completed Title"
              })}
            </Badge>
          )
        };
      }
    }

    this.setState({ tabs: tabData });
  }

  componentWillUnmount() {
    clearInterval(this.queueMyInterval);
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <span>
        <FormattedMessage id="queue.page.title" />
      </span>
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed(), null);
    showNavbar(true);
    showTabbar(false);
  };

  refreshAllQueue = () => {
    const { authToken } = this.props;

    if (authToken) {
      this.fetchQueueCompleteItemData(false);
      this.fetchQueueItemData(false);
    }
  };

  fetchQueueItemData = (loading = true) => {
    const { getUserQueueItemRequest } = this.props;

    getUserQueueItemRequest && getUserQueueItemRequest(loading);
  };

  fetchQueueCompleteItemData = (loading = true) => {
    const { getUserQueueCompleteItemRequest } = this.props;

    getUserQueueCompleteItemRequest && getUserQueueCompleteItemRequest(loading);
  };

  getInProgressDataList = () => {
    const { inProgressData } = this.props;
    const emptyData = { type: "empty" };

    return inProgressData && inProgressData.length > 0
      ? inProgressData
      : emptyData;
  };

  getCompletedDataList = () => {
    const { completeData } = this.props;
    const emptyData = { type: "empty" };

    return completeData && completeData.length > 0 ? completeData : emptyData;
  };

  getLoadingIndicator = () => {
    const { inProgressLoading, completeLoading } = this.props;
    const { current } = this.state;

    if (
      (inProgressLoading && current === 0) ||
      (completeLoading && current === 1)
    ) {
      return <LoadingIndicator />;
    }

    return false;
  };

  onIndexChange = (tab, index) => {
    let tabData = this.state.tabs;

    if (index === 1) {
      tabData[1] = {
        title: intl.formatMessage({
          id: "queue.page.tab.completed.title",
          defaultMessage: "Completed",
          description: "Queue Page Completed Title"
        })
      };
    }

    this.setState({ tabs: tabData, current: index });
  };

  onInProgressRefresh = () => {
    this.fetchQueueItemData();
  };

  onCompleteRefresh = () => {
    this.fetchQueueCompleteItemData();
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  render() {
    const { animationClass, tabs } = this.state;
    const { authToken } = this.props;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <Tabs
          tabs={tabs}
          initalPage={"details"}
          swipeable={false}
          tabBarUnderlineStyle={{
            height: "6px",
            backgroundColor: Theme.PrimaryColor,
            border: "unset"
          }}
          tabBarTextStyle={{
            fontSize: "1em"
          }}
          tabBarActiveTextColor={Theme.PrimaryColor}
          tabBarInactiveTextColor={"grey"}
          renderTabBar={props => <Tabs.DefaultTabBar {...props} />}
          onChange={this.onIndexChange}
        >
          <QueueListing
            {...this.props}
            auth={authToken}
            items={this.getInProgressDataList()}
            onRefresh={this.onInProgressRefresh}
          />
          <QueueListing
            {...this.props}
            auth={authToken}
            items={this.getCompletedDataList()}
            onRefresh={this.onCompleteRefresh}
          />
        </Tabs>
      </StyledContainer>
    );
  }
}

FoodQueuePage.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  authToken: PropTypes.string,
  inProgressData: PropTypes.array,
  inProgressLoading: PropTypes.bool,
  readyData: PropTypes.array,
  readyLoading: PropTypes.bool,
  completeData: PropTypes.array,
  completeLoading: PropTypes.bool,
  getUserQueueItemRequest: PropTypes.func,
  getUserQueueReadyItemRequest: PropTypes.func,
  getUserQueueCompleteItemRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    inProgressData: selectors.getQueueInProgressItem(state),
    inProgressLoading: selectors.getQueueInProgressLoading(state),
    readyData: selectors.getQueueReadyItem(state),
    readyLoading: selectors.getQueueReadyLoading(state),
    completeData: selectors.getQueueCompleteItem(state),
    completeLoading: selectors.getQueueCompleteLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserQueueItemRequest: (loading = true) =>
      dispatch(userAction.getUserQueueListRequest(loading)),
    getUserQueueReadyItemRequest: (loading = true) =>
      dispatch(userAction.getUserQueueReadyItemRequest(loading)),
    getUserQueueCompleteItemRequest: (loading = true) =>
      dispatch(userAction.getUserQueueCompleteItemRequest(loading))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FoodQueuePage);



// WEBPACK FOOTER //
// ./src/containers/FoodQueuePage/index.js